import AbstractSystem from "../all/AbstractSystem";

class KepplerSystem extends AbstractSystem {

    exit(param) {
        //It doesn't close the app but it show the main manu instead.
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'closeApp'
            }));
        
        return;
    }
}

export default KepplerSystem;



// WEBPACK FOOTER //
// ./src/devices/kepler/System.js